import React from 'react';
import { Image, useTheme } from '@chakra-ui/react';

interface LogoProps {
  width: string;
  yellow?: boolean;
}

const Logo = ({ width, yellow = false, ...props }: LogoProps) => {
  const theme = useTheme();

  return (
    <Image
      {...props}
      alt="PetSafe logo"
      maxH="70%"
      minW={width}
      objectFit="contain"
      src={yellow ? theme.images.yellowLogo : theme.images.logo}
      width={width}
    />
  );
};

export default Logo;
